/**
 * Admin Home Widgets Module Routes (E19 Fase 5).
 *
 * Rota single `/admin/home-widgets` — tela admin que configura, por perfil
 * RBAC, quais widgets da Home aparecem e em que ordem (persistido no banco).
 *
 * **Por que NÃO registrar em `system_modules`** (CLAUDE.md "criar módulo
 * novo"): é tela admin meta — equivalente a `/admin/perfis`, `/admin/permissoes`
 * e `/admin/rbac-audit` (que também não estão em `system_modules`). Registrar
 * poluiria o catálogo + exigiria health check sem ganho prático.
 *
 * **Permission gate:** backend exige `home_widgets:manage` (GET + PUT).
 * `RequirePermission` no frontend evita request inútil + redireciona pra
 * `/unauthorized` se o user não tem.
 */

import { lazy } from "react";

import { ModuleRoutes } from "../types";

const HomeWidgetsPage = lazy(() => import("@/pages/admin/HomeWidgetsPage"));

export const adminHomeWidgetsRoutes: ModuleRoutes = {
  moduleId: "admin_home_widgets",
  basePath: "/admin/home-widgets",
  routes: [
    {
      path: "/admin/home-widgets",
      element: <HomeWidgetsPage />,
      permission: { resource: "home_widgets", action: "manage" },
    },
  ],
};
